function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import merge from "lodash/merge";
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

export default function createTypography() {
  var typography = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _typography$fontFamil = typography.fontFamilyPrimary,
      fontFamilyPrimary = _typography$fontFamil === void 0 ? '"Open Sans", Arial, "Helvetica Neue", Helvetica, sans-serif' : _typography$fontFamil,
      _typography$fontFamil2 = typography.fontFamilySecondary,
      fontFamilySecondary = _typography$fontFamil2 === void 0 ? '"Varela Round", Arial, "Helvetica Neue", Helvetica, sans-serif' : _typography$fontFamil2,
      _typography$fontSize = typography.fontSize,
      fontSize = _typography$fontSize === void 0 ? 14 : _typography$fontSize,
      _typography$fontWeigh = typography.fontWeightLight,
      fontWeightLight = _typography$fontWeigh === void 0 ? 300 : _typography$fontWeigh,
      _typography$fontWeigh2 = typography.fontWeightRegular,
      fontWeightRegular = _typography$fontWeigh2 === void 0 ? 400 : _typography$fontWeigh2,
      _typography$fontWeigh3 = typography.fontWeightMedium,
      fontWeightMedium = _typography$fontWeigh3 === void 0 ? 600 : _typography$fontWeigh3,
      _typography$htmlFontS = typography.htmlFontSize,
      htmlFontSize = _typography$htmlFontS === void 0 ? 16 : _typography$htmlFontS,
      allVariants = typography.allVariants,
      other = _objectWithoutProperties(typography, ["fontFamilyPrimary", "fontFamilySecondary", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "allVariants"]);

  var coef = fontSize / 14;

  var pxToRem = function pxToRem(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight) {
    return _objectSpread({
      // color: palette.text.primary,
      fontFamilyPrimary: fontFamilyPrimary,
      fontFamilySecondary: fontFamilySecondary,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following http://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 40, 1),
    h2: buildVariant(fontWeightLight, 32, 1),
    h3: buildVariant(fontWeightRegular, 24, 1.04),
    h4: buildVariant(fontWeightRegular, 20, 1.17),
    h5: buildVariant(fontWeightRegular, 18, 1.33),
    h6: buildVariant(fontWeightMedium, 14, 1.6),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75),
    body1: buildVariant(fontWeightRegular, 14, 1.5),
    body2: buildVariant(fontWeightRegular, 12, 1.5)
  };
  return merge(_objectSpread({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    fontFamilyPrimary: fontFamilyPrimary,
    fontFamilySecondary: fontFamilySecondary,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium
  }, variants), other);
}